import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/cadastro/categoria' };
/////////////////////////////////////////////////////////////////////////////////

export function createAnimalCategoriaCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateAnimalCategoriaCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listAnimalCategoriaCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findAnimalCategoriaCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deleteAnimalCategoriaCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

